import { SurveyorInputSlice } from './../components/Surveyor/reducers/SurveyorInputReducer';
import { AgentSearchSlice } from './../components/Agent/reducers/AgentSearchReducer';
import { FixtureInvoiceInputSlice } from './../components/FixtureManagement/reducers/FixtureInvoiceInputReducer';
import { MyFixtureSlice } from './../components/MyFixtures/reducers/MyFixtureReducer';
import { FixturePreviewSlice } from './../components/FixtureManagement/reducers/FixturePreviewReducer';
import { FixtureInputSlice } from './../components/FixtureManagement/reducers/FixtureInputReducer';
import { FixtureSearchSlice } from './../components/FixtureManagement/reducers/FixtureSearchReducer';
import { InvalidMarketInfoSlice } from './../components/InvalidCheck/reducers/InvalidMarketInfoReducer';
import { UserManagementSlice } from '../components/UserManagement/reducers/UserManagementReducer';
import { DraggableMenuSlice } from './../components/DraggableMenu/reducers/DraggableMenuReducer';
import { MatchingPreviewSlice } from './../components/MatchingPreview/reducers/MatchingPreviewReducer';
import { CargoTypeSelectorSlice } from '../components/CargoTypeSelector/reducers/CargoTypeSelectorReducer';
import { CargoInputSlice } from './../components/Cargo/reducers/CargoInputReducer';
import { SavedSearchSlice } from './../components/SavedSearch/reducers/SavedSearchReducer';
import { TonnageOperatorHistoryModalSlice } from './../components/Tonnage/reducers/TonnageOperatorHistoryReducer';
import { ContactSelectorSlice } from './../components/ContactSelector/reducers/ContactSelectorReducer';
import { PortSelectorSlice } from './../components/PortSelector/reducers/PortSelectorReducer';
import { TonnageSlice } from '../components/Tonnage/reducers/TonnageInputReducer';
import { LoginSlice } from './../components/Login/reducers/LoginReducer';
import { UserProfileSlice } from './../components/Login/reducers/UserProfileReducer';
import { LoadingViewSlice } from './../components/LoadingView/reducers/LoadingViewReducer';
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { TonnageSearchSlice } from '../components/Tonnage/reducers/TonnageSearchReducer';
import { CargoSearchSlice } from '../components/Cargo/reducers/CargoSearchReducer';
import { TonnageQuickInputSlice } from '../components/QuickInput/reducers/TonnageQuickInputReducer';
import { QuickInputSlice } from '../components/QuickInput/reducers/QuickInputReducer';
import { CargoQuickInputSlice } from '../components/QuickInput/reducers/CargoQuickInputReducer';
import { ContactInputSlice } from '../components/Contact/reducers/ContactInputReducer';
import { ContactSearchSlice } from '../components/Contact/reducers/ContactSearchReducer';
import { AdminLeftMenuSlice } from '../components/AdminLeftMenu/reducers/AdminLeftMenuReducer';
import { PortManagementSlice } from '../components/PortManagement/reducers/PortInputReducer';
import { MarketInfoInputSlice } from '../components/MarketInfo/reducers/MarketInfoInputReducer';
import { MarketInfoSearchSlice } from '../components/MarketInfo/reducers/MarketInfoSearchReducer';
import { CheckDuplicateSlice } from '../components/CheckDuplicate/reducers/CheckDuplicateReducer';
import { UserAnalyticsSlice } from '../components/UserAnalytics/reducers/UserAnalyticsReducer';
import { StatSlice } from '../components/Stat/reducers/StatReducer';
import { DatabaseBackupSlice } from '../components/DatabaseBackup/reducers/DatabaseBackupReducer';
import { CargoTypeManagementSlice } from '../components/CargoTypeManagement/reducers/CargoTypeManagementReducer';
import { InvalidTonnageSlice } from '../components/InvalidCheck/reducers/InvalidTonnageReducer';
import { InvalidCargoSlice } from '../components/InvalidCheck/reducers/InvalidCargoReducer';
import { MarketingEmailSearchSlice } from '../components/MarketingEmail/reducers/MarketingEmailSearchReducer';
import { EmailEditorSlice } from '../components/EmailEditorModal/reducers/EmailEditorReducer';
import { EmailSignatureSlice } from '../components/EmailSignature/reducers/EmailSignatureReducer';
import { UserSelectorSlice } from '../components/UserSelector/reducers/UserSelectorReducer';
import { SupportSheetSlice } from '../components/SupportSheet/reducers/SupportSheetReducer';
import { FixtureEvaluationInputSlice } from '../components/FixtureManagement/reducers/FixtureEvaluationInputReducer';
import { SupportSheetPrincipleSlice } from '../components/SupportSheet/components/SupportSheetPrinciple/reducers/SupportSheetPrincipleReducer';
import { SupportSheetHelpTextSlice } from '../components/SupportSheet/components/SupportSheetHelpText/reducers/SupportSheetHelpTextReducer';
import { FixtureQuickSummarySlice } from '../components/FixtureManagement/components/FixtureQuickSummary/reducers/FixtureQuickSummaryReducer';
import { AgentInputSlice } from '../components/Agent/reducers/AgentInputReducer';
import { AgentSelectorSlice } from '../components/AgentSelector/reducers/AgentSelectorReducer';
import { CompanyNamePICInputSlice } from '../components/CompanyNamePIC/reducers/CompanyNamePICInputReducer';
import { CompanyNamePICSearchSlice } from '../components/CompanyNamePIC/reducers/CompanyNamePICSearchReducer';
import { CompanyNamePICSelectorSlice } from '../components/CompanyNamePICSelector/reducers/CompanyNamePICSelectorReducer';
import { SurveyorSearchSlice } from '../components/Surveyor/reducers/SurveyorSearchReducer';
import { SurveyorSelectorSlice } from '../components/SurveyorSelector/reducers/SurveyorSelectorReducer';
import { MyFixtureSearchSlice } from '../components/MyFixtures/reducers/MyFixtureSearchReducer';
import { BrokerAccountInputSlice } from '../components/BrokerAccount/reducers/BrokerAccountInputReducer';
import { BrokerAccountSearchSlice } from '../components/BrokerAccount/reducers/BrokerAccountSearchReducer';
import { CashInputSlice } from '../components/Cash/reducers/CashInputReducer';
import { CashAccountSlice } from '../components/Cash/reducers/CashAccountReducer';
import { InvestmentInputSlice } from '../components/Investment/reducers/InvestmentInputReducer';
import { InvestmentSearchSlice } from '../components/Investment/reducers/InvestmentSearchReducer';
import { ExpenseSearchSlice } from '../components/Expense/reducers/ExpenseSearchReducer';
import { ExpenseInputSlice } from '../components/Expense/reducers/ExpenseInputReducer';
import { CareSearchSlice } from '../components/Care/reducers/CareSearchReducer';
import { CareInputSlice } from '../components/Care/reducers/CareInputReducer';
import { CashTableSlice } from '../components/Cash/reducers/CashTableReducer';
import { CashDetailSlice } from '../components/Cash/reducers/CashDetailReducer';
import { StockInputSlice } from '../components/Stock/reducers/StockInputReducer';
import { StockSearchSlice } from '../components/Stock/reducers/StockSearchReducer';
import { TotalSummarySearchSlice } from '../components/TotalSummary/reducers/TotalSummarySearchReducer';
import { ClassificationSlice } from '../components/Classification/reducers/ClassificationReducer';
import { CompanyNameCombineInputSlice } from '../components/CompanyNameCombine/reducers/CompanyNameCombineInputReducer';
import { CompanyNameCombineSearchSlice } from '../components/CompanyNameCombine/reducers/CompanyNameCombineSearchReducer';

export const store = configureStore({
    reducer: {
        loadingView: LoadingViewSlice.reducer,
        userProfile: UserProfileSlice.reducer,
        login: LoginSlice.reducer,
        tonnage: TonnageSlice.reducer,
        portSelector: PortSelectorSlice.reducer,
        contactSelectorSelector: ContactSelectorSlice.reducer,
        tonnageOperatorHistoryModalSelector: TonnageOperatorHistoryModalSlice.reducer,
        tonnageSearchSelector: TonnageSearchSlice.reducer,
        savedSearchSelector: SavedSearchSlice.reducer,
        cargoInput: CargoInputSlice.reducer,
        cargoSearch: CargoSearchSlice.reducer,
        cargoType: CargoTypeSelectorSlice.reducer,
        matchingPreview: MatchingPreviewSlice.reducer,
        draggableMenu: DraggableMenuSlice.reducer,
        tonnageQuickInput: TonnageQuickInputSlice.reducer,
        quickInput: QuickInputSlice.reducer,
        cargoQuickInput: CargoQuickInputSlice.reducer,
        contactInput: ContactInputSlice.reducer,
        contactSearch: ContactSearchSlice.reducer,
        adminLeftMenu: AdminLeftMenuSlice.reducer,
        userManagement: UserManagementSlice.reducer,
        portManagement: PortManagementSlice.reducer,
        marketInfoInput: MarketInfoInputSlice.reducer,
        marketInfoSearch: MarketInfoSearchSlice.reducer,
        checkDuplicate: CheckDuplicateSlice.reducer,
        userAnalytics: UserAnalyticsSlice.reducer,
        stat: StatSlice.reducer,
        databaseBackup: DatabaseBackupSlice.reducer,
        cargoTypeManagement: CargoTypeManagementSlice.reducer,
        invalidTonnage: InvalidTonnageSlice.reducer,
        invalidCargo: InvalidCargoSlice.reducer,
        invalidMarketInfo: InvalidMarketInfoSlice.reducer,
        marketingEmailSearch: MarketingEmailSearchSlice.reducer,
        emailEditor: EmailEditorSlice.reducer,
        emailSignature: EmailSignatureSlice.reducer,
        fixtureSearch: FixtureSearchSlice.reducer,
        fixtureInput: FixtureInputSlice.reducer,
        userSelector: UserSelectorSlice.reducer,
        supportSheet: SupportSheetSlice.reducer,
        principle: SupportSheetPrincipleSlice.reducer,
        fixturePreview: FixturePreviewSlice.reducer,
        myFixture: MyFixtureSlice.reducer,
        supportSheetHelperText: SupportSheetHelpTextSlice.reducer,
        fixtureInvoiceInput: FixtureInvoiceInputSlice.reducer,
        fixtureEvaluationInput: FixtureEvaluationInputSlice.reducer,
        fixtureQuickSummary: FixtureQuickSummarySlice.reducer,
        agentInput: AgentInputSlice.reducer,
        agentSearch: AgentSearchSlice.reducer,
        agentSelector: AgentSelectorSlice.reducer,
        companyNamePICInput: CompanyNamePICInputSlice.reducer,
        companyNamePICSearch: CompanyNamePICSearchSlice.reducer,
        companyNamePICSelector: CompanyNamePICSelectorSlice.reducer,
        surveyorSearch: SurveyorSearchSlice.reducer,
        surveyorInput: SurveyorInputSlice.reducer,
        surveyorSelector: SurveyorSelectorSlice.reducer,
        myFixtureSearch: MyFixtureSearchSlice.reducer,
        brokerAccountInput: BrokerAccountInputSlice.reducer,
        brokerAccountSearch: BrokerAccountSearchSlice.reducer,
        cashInput: CashInputSlice.reducer,
        investmentInput: InvestmentInputSlice.reducer,
        investmentSearch: InvestmentSearchSlice.reducer,
        ExpenseSearch: ExpenseSearchSlice.reducer,
        ExpenseInput: ExpenseInputSlice.reducer,
        careSearch: CareSearchSlice.reducer,
        careInput: CareInputSlice.reducer,
        cashAccount: CashAccountSlice.reducer,
        cashTable: CashTableSlice.reducer,
        cashDetail: CashDetailSlice.reducer,
        stockInput: StockInputSlice.reducer,
        stockSearch: StockSearchSlice.reducer,
        totalSummarySearch: TotalSummarySearchSlice.reducer,
        classification: ClassificationSlice.reducer,
        companyNameCombineInput: CompanyNameCombineInputSlice.reducer,
        companyNameCombineSearch: CompanyNameCombineSearchSlice.reducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
